const nav = {
  Contract: ["合约", "Contract"],
  New: ["新建合约", "New"],
  Edit: ["编辑合约", "Edit"],
  Draft: ["草稿合约", "Draft"],
  Signing: ["待签署", "Signing"],
  Completed: ["已完成合约", "Completed"],
  Rejected: ["已拒绝合约", "Rejected"],
  Expired: ["过期合约", "Expired"],
  Terminate: ["终止合约", "Terminate"],
  Validating: ["验证合约", "Validating"],
  Trash: ["垃圾箱", "Trash"],
  Directory: ["通讯录", "Directory"],
  ViewProfile: ["个人设置", "View Profile"],
  MyFiles: ["我的文件", "My Files"],
  Enterprise: ["企业应用", "Enterprise"],
  Version: ["版本信息", "Version"],
  LogOut: ["退出登录", "Log Out"],
};

export default nav;
